<template>
  <article
    class="aroma-history-item"
    role="button"
    tabindex="0"
    @click="$emit('select', item)"
    @keyup.enter="$emit('select', item)"
    @keyup.space.prevent="$emit('select', item)"
  >
    <div class="aroma-history-item__primary">
      <strong class="aroma-history-item__name">{{ reportName }}</strong>
      <div class="aroma-history-item__summary" :class="`is-${status}`">
        <span>睡眠效率</span>
        <strong>{{ efficiency }}</strong>
        <span class="aroma-history-item__quality">{{ item.sleepQuality || '--' }}</span>
      </div>
      <time :datetime="item.reportDate">{{ date }}</time>
    </div>
    <div class="aroma-history-item__secondary"><span>{{ item.sn || fallbackSn }}</span></div>
  </article>
</template>

<script>
import { formatReportDate, formatReportName, formatSleepEfficiency, sleepEfficiencyStatus } from '@/utils/aroma-report-list'

export default {
  name: 'AromaReportHistoryItem',
  props: {
    item: { type: Object, required: true },
    fallbackSn: { type: String, default: '' }
  },
  computed: {
    reportName () { return formatReportName(this.item) },
    date () { return formatReportDate(this.item.reportDate) },
    efficiency () { return formatSleepEfficiency(this.item.sleepEfficiency) },
    status () { return sleepEfficiencyStatus(this.item.sleepEfficiency) }
  }
}
</script>

<style scoped lang="scss">
.aroma-history-item { min-width: 0; margin: 0; padding: 17px 16px 15px; border: 1px solid #f0f1f3; border-radius: 8px; outline: none; background: #fff; box-shadow: 0 2px 8px rgba(31,35,41,.04); box-sizing: border-box; cursor: pointer; transition: background-color 120ms ease, transform 120ms ease; }
.aroma-history-item:active { background: #fafbfc; transform: scale(.995); }
.aroma-history-item:focus-visible { box-shadow: 0 0 0 2px rgba(39,121,255,.22); }
.aroma-history-item__primary { display: grid; min-width: 0; align-items: center; grid-template-columns: minmax(54px,auto) minmax(0,1fr) auto; gap: 10px; }
.aroma-history-item__primary time { color: #858a92; font-size: 14px; line-height: 22px; white-space: nowrap; }
.aroma-history-item__name { min-width: 0; overflow: hidden; color: #344263; font-size: 18px; font-weight: 700; line-height: 26px; text-overflow: ellipsis; white-space: nowrap; }
.aroma-history-item__summary { display: flex; min-width: 0; align-items: baseline; gap: 4px; overflow: hidden; color: #8f959e; }
.aroma-history-item__summary > span:first-child { flex: none; font-size: 12px; line-height: 20px; }
.aroma-history-item__summary > strong { flex: none; font-size: 20px; font-weight: 700; line-height: 28px; }
.aroma-history-item__summary.is-good { color: #168a4a; }
.aroma-history-item__summary.is-fair { color: #e77b00; }
.aroma-history-item__summary.is-poor { color: #e5484d; }
.aroma-history-item__quality { min-width: 0; overflow: hidden; font-size: 13px; line-height: 20px; text-overflow: ellipsis; white-space: nowrap; }
.aroma-history-item__secondary { display: grid; min-width: 0; margin-top: 11px; grid-template-columns: minmax(0,1fr) minmax(96px,auto); gap: 14px; }
.aroma-history-item__secondary span { min-width: 0; overflow: hidden; color: #8a8f98; font-size: 13px; line-height: 21px; text-overflow: ellipsis; white-space: nowrap; }
@media (max-width: 360px) {
  .aroma-history-item { padding: 15px 13px 14px; }
  .aroma-history-item__primary { grid-template-columns: minmax(48px,auto) minmax(0,1fr) auto; gap: 7px; }
  .aroma-history-item__primary time { font-size: 12px; }
  .aroma-history-item__name { font-size: 16px; }
  .aroma-history-item__summary > span:first-child { display: none; }
  .aroma-history-item__summary > strong { font-size: 18px; }
}
</style>
